import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import PaymentIcon from "@mui/icons-material/Payment";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
    [theme.breakpoints.only("sm")]: { padding: theme.spacing(2) },
    [theme.breakpoints.down("sm")]: { paddingTop: theme.spacing(2) },
  },
  paper: {
    maxWidth: 400,
    [theme.breakpoints.down("md")]: { maxWidth: "100%" },
    // [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
    // [theme.breakpoints.down("md")]: { padding: theme.spacing(2) },
  },
  customIconUnauth: {
    color: "#1c355e",
    height: 200,
    width: 200,
    opacity: 0.1,
  },
  customTypoUnauth: {
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -160,
  },
  paperNoData: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 280,
    width: 320,
  },
  paperUpdate: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 320,
    width: 320,
  },
  customTypoUpdate: {
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -150,
  },
  cardHeader: {
    variant: "h1",
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center",
  },
}));


const ThankYouCard = () => {
  const { t } = useTranslation();
  const classes = useStyles();


  return (
    <Container sx={{ marginTop: "50px" }}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Paper className={classes.paperNoData} elevation={2}>
          <Grid container direction="column">
            <Grid item>
              <Typography className={classes.cardHeader}>
                {t("registration.autoPayments")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: 4, textAlign: "center" }}>
              <PaymentIcon className={classes.customIconUnauth} />
              <Typography className={classes.customTypoUnauth}>
                {t("registration.autoPaymentThankYou")}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Container>
  );
};

export default ThankYouCard;